/**
 * Helper function for easier and cleaner building of className strings.
 * It filters falsy values and concatenates all remaining values with spaces.
 */
export const classes = (...classNames: (string | number | null | boolean | undefined)[]) =>
  classNames.reduce(
    (res: string, className) => (className ? `${res}${res ? ' ' : ''}${className}` : res),
    '',
  );
